"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var dealerListHeaderStyles_1 = require("./dealerListHeaderStyles");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var DealerListHeader = function () {
    var styles = dealerListHeaderStyles_1.default();
    return (<core_1.Box className={styles.headerContainer}>
      <core_1.Typography variant={'body1'} className={styles.headerTitle} data-test="text:dealerList:header">
        <Translation_1.default id={'trans__checkout__dealers_page__list_title'}/>
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = DealerListHeader;
